import React from "react";
import { Link, withRouter } from "react-router-dom";
import { HashLink as Hlink } from "react-router-hash-link";
import { ContainerWrapper } from "../../../Components/Utils";
import HomeIcon from "../../../Images/Misc/home-icon.png";
import CapabilityIcon from "../../../Images/Misc/capability-icon.png";
import LinkIcon from "../../../Images/Misc/link-icon.png";
import ServicesIcon from "../../../Images/Misc/services-icon.png";

function SecurityBoxes() {
  return (
    <ContainerWrapper textAlign="justify">
      <h3 className="banner-item__header w-100 text-left">Cybersecurity</h3>
      <p>Grow online securely and compete in new markets enabled by cybersecurity.</p>
      <div className="gn__grid flex-center">
        <Hlink to="/scalecamps/#ceb" className="security__card">
          <div className="sc-top">
          <img src={HomeIcon} alt="Cybersecurity for Entrepreneurs Scalecamp" title="Cybersecurity for Entrepreneurs Scalecamp"/>
          </div>
          <div className="sc-body">
            <span>Cybersecurity for entrepreneurs scalecamp</span>
          </div>
        </Hlink>
        <Hlink to="/assess/#cyber" className="security__card">
          <div className="sc-top">
            <img src={CapabilityIcon} alt="Cybersecurity for entrepreneurs scalecamp" title="Cybersecurity for entrepreneurs scalecamp"/>
          </div>
          <div className="sc-body">
            <span>Assess capability to securely grow</span>         
          </div> 
        </Hlink>
        <Link to="/assets" className="security__card">
          <div className="sc-top">
            <img src={LinkIcon} alt="Cybersecurity for entrepreneurs scalecamp" title="Cybersecurity for entrepreneurs scalecamp"/>
          </div>
          <div className="sc-body">
            <span>Assets</span>         
          </div> 
        </Link>
        <Link to="/security" className="security__card">
          <div className="sc-top">
            <img src={ServicesIcon} alt="Cybersecurity for entrepreneurs scalecamp" title="Cybersecurity for entrepreneurs scalecamp"/>
          </div>
          <div className="sc-body">
            <span>Security services</span>         
          </div> 
        </Link>
      </div>
    </ContainerWrapper>
  )
}

export default withRouter(SecurityBoxes)



// WEBPACK FOOTER //
// ./src/Pages/BannerItems/Pages/SecurityBoxes.js